import login from './login';

export default redux.combineReducers({ login });
